__turbopack_context__.v({
  "picture": "PasswordUpdated-module__dXwKYq__picture",
  "wrapper": "PasswordUpdated-module__dXwKYq__wrapper",
});
